import {
  GET_INSURANCE_CARRIERS,
  GET_INSURANCE_CARRIERS_SUCCESS,
  GET_INSURANCE_CARRIERS_ERROR
} from "./actionTypes"

export const getInsuranceCarriers = () => {
  return {
    type: GET_INSURANCE_CARRIERS
  }
}

export const getInsuranceCarriersSuccess = carriers => {
  return {
    type: GET_INSURANCE_CARRIERS_SUCCESS,
    payload: carriers,
  }
}

export const getInsuranceCarriersError = error => {
  return {
    type: GET_INSURANCE_CARRIERS_ERROR,
    payload: error,
  }
}
